import { FC } from "react"
import { Modal, ModalBody } from "reactstrap"
import { ModalUploadProps } from "../../interfaces"
import UploadForm from "./UploadForm"
import { CANCEL } from "../../constants"

const ModalUpload: FC<ModalUploadProps> = ({ isOpen, toggle, refetch, adminImport, isContactImport }) => {
  return (
    <Modal Modal isOpen={isOpen} toggle={toggle} className="revampDialog revampDialogWidth">
      <ModalBody className="pl-5 pr-5">
        <UploadForm toggle={toggle} refetch={refetch} adminImport={adminImport} isContactImport={isContactImport}>
          {toggle && <button onClick={toggle} className="buttonPrimary mr-3" style={{
            backgroundColor: "red",
            margin: 0
          }}
            type="button">
            {CANCEL}
          </button>}
        </UploadForm>
      </ModalBody>
    </Modal>
  )
}
export default ModalUpload